export default "__VITE_ASSET__DafG1Xf2__"